import Lottie from "lottie-react";
import loading from "./loading.json";

export default function LottieLoading () {
  return <div className="h-25 w-25">
      <Lottie animationData={loading} loop={true} />
    </div> 
}